import {
  IActionRulesSubLogicStatements,
  IActionRulesSubLogicStatementValue
} from '@aytm/app/swidget/base/actions/types'
import { IImageAsset } from '@aytm/app/swidget/base/modules/images/types'
import { IPreviewOptions } from '@aytm/app/swidget/base/modules/preview/types'

export default function textWithOptionsOld(
  t: string,
  options: IPreviewOptions,
  rules: IActionRulesSubLogicStatements,
  hide?: IActionRulesSubLogicStatementValue
): string {
  if (!options.showHidden && hide?.condition) return ''

  let labelText = Array.isArray(t) ? JSON.stringify(t) : t || ''
  // if (labelText.length > 84 && crop) labelText = labelText.slice(0, 81) + '...'
  const braceReg1 = new RegExp('\\[\\[', 'g')
  const braceReg2 = new RegExp('\\]\\]', 'g')
  const braceReg3 = new RegExp('⟨⟨⟨⟨⟨⟨', 'g')
  const braceReg4 = new RegExp('⟩⟩⟩⟩⟩⟩', 'g')
  labelText = labelText.replace(braceReg1, '⟨⟨⟨⟨⟨⟨').replace(braceReg2, '⟩⟩⟩⟩⟩⟩')

  if (rules) {
    Object.keys(rules).forEach(function (key) {
      const regexp = new RegExp(key.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&'), 'gi')
      const debugObj = rules[key]
      let str = ''
      if (debugObj.invalid) {
        str = '<span style="color:#c1272d">' + key + '</span>'
      } else if (!options.showLogic && 'string' === typeof debugObj?.text) {
        str = debugObj.text.replace(braceReg1, '⟨⟨⟨⟨⟨⟨').replace(braceReg2, '⟩⟩⟩⟩⟩⟩') || ''
      } else {
        if (debugObj.variables) {
          const unquoted = key.split(/(["'])/)

          let inStr = false
          for (let i = 0; i < unquoted.length; i++) {
            if ('"' === unquoted[i] || "'" === unquoted[i]) inStr = !inStr

            !inStr &&
              Object.keys(debugObj.variables).forEach(function (varb) {
                let varValue = debugObj.variables[varb]

                if ('' === varValue) varValue = '<i>empty</i>'

                if (
                  varValue &&
                  'object' === typeof varValue &&
                  Boolean(Object.getOwnPropertyDescriptor(varValue, 'original_path'))
                )
                  varValue = `<img src="${(varValue as IImageAsset).original_url}"></img>`

                if (varValue && 'string' === typeof varValue) {
                  varValue = varValue.replace(braceReg1, '[').replace(braceReg2, ']')
                  if (varValue.toString().length > 120) varValue = varValue.toString().slice(0, 120) + '...'
                }

                let reg = new RegExp('\\b(' + varb.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + ')\\b', 'gi')
                unquoted[i] = unquoted[i].replace(
                  reg,
                  `<span class="logicRefInner">$1<div class="logicHint"><div class="logicValue">${varValue.toString()}</div><div class="logicArrow"></div></div></span>`
                )
                if ('t' == varb[varb.length - 1]) {
                  const vars = varb.slice(0, Math.max(0, varb.length - 1))
                  reg = new RegExp('\\b(' + vars.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + ')\\b', 'gi')
                  unquoted[i] = unquoted[i].replace(
                    reg,
                    `<span class="logicRefInner">$1<div class="logicHint"><div class="logicValue">${varValue.toString()}<div class="logicArrow"></div></div></div></span>`
                  )
                }
              })
          }
          str = '<a class="logicRef">' + unquoted.join('') + '</a>'
        } else {
          str = '<a class="logicRef">' + key + '</a>'
        }
      }

      labelText = labelText.replace(regexp, str)

      // if (rules[key].image && rules[key].condition) labelImage = rules[key].image
    })
  }
  // console.log(showLogic)
  return labelText.replace(braceReg3, '[').replace(braceReg4, ']')
}
